import FormModal from '@insurancemenu/imenu-components-lib/dist/components/modals/FormModal';
import React from 'react';
import { colors, InputText } from '@insurancemenu/imenu-components-lib';
import { observer } from 'mobx-react-lite';
import { Edit } from '@insurancemenu/imenu-components-lib/dist/icons';
import { EditDocumentModalStore } from 'store/modules/upload-documents/ui-stores/editDocumentModalStore';
import { FormBodyWrapperStyled, TextAreaStyled } from './styles';
import {
  EDIT_DOCUMENT_DESCRIPTION_TEST_ID,
  EDIT_DOCUMENT_MODAL_TEST_ID,
  EDIT_DOCUMENT_NAME_TEST_ID,
} from '../constants';

interface Props {
  modalStore: EditDocumentModalStore;
}

const EditDocumentModal: React.FC<Props> = observer(
  ({ modalStore: { form, isLoading, isDataValid, isVisible, requestDocumentAction, closeEditModal } }) => {
    const onSubmit = async (): Promise<void> => {
      await requestDocumentAction();
    };

    return isVisible ? (
      <FormModal
        show={isVisible}
        onClose={closeEditModal}
        title="Edit Document"
        subtitle="Edit the name or description of the document."
        icon={<Edit width="5.6rem" color={colors.green[600]} />}
        formContent={
          <FormBodyWrapperStyled>
            <InputText
              label="Document Name"
              maxLength={30}
              value={form.fields.docName.value}
              name="docName"
              width="100%"
              onChange={form.onFieldChange}
              validationPassed={!form.fields.docName.unpassedValidationMsg}
              validationMessage={form.fields.docName.unpassedValidationMsg}
              data-test-id={EDIT_DOCUMENT_NAME_TEST_ID}
            />
            <TextAreaStyled
              label="Description"
              maxLength={500}
              name="description"
              width="100%"
              value={form.fields.description.value}
              onChange={form.onFieldChange}
              validationPassed={!form.fields.description.unpassedValidationMsg}
              validationMessage={form.fields.description.unpassedValidationMsg}
              data-test-id={EDIT_DOCUMENT_DESCRIPTION_TEST_ID}
            />
          </FormBodyWrapperStyled>
        }
        loading={isLoading}
        isFormValid={isDataValid}
        closeButtonText="Cancel"
        submitButtonText="Save"
        onSubmit={onSubmit}
        data-test-id={EDIT_DOCUMENT_MODAL_TEST_ID}
      />
    ) : null;
  },
);

export default EditDocumentModal;
